import { api } from "./api";

export const CreateSyllabus = async (data) =>{
    return await api.post(`syllabus/add`,data)
}

export const FetchSyllabus = async (addUrl = '')=>{
    let url = `syllabus/list?${addUrl}`
    return await api.get(url)
}
export const FetchTrackingSyllabus = async (addUrl = '')=>{
    let url = `syllabus/tracker/list?${addUrl}`
    return await api.get(url)
}

export const UpdateSyllabus = async (data) =>{
    return await api.post(`syllabus/update`,data)
}
export const DeleteSyllabus = async (id) =>{
    return await api.post(`syllabus/delete`,{id})
}


// Syllabus Assign

export const AssignSyllabus = async (data) =>{
    return await api.post(`syllabus/tracker/add`,data)
}

export const AssignSyllabusStatus = async (data) =>{
    return await api.post(`syllabus/tracker/status`,data)
}

export const AssignSyllabusDelete = async (id) =>{
    return await api.post(`syllabus/tracker/delete`,{id})
}

export const AssignSyllabusUpdate = async (data) =>{
    return await api.post(`syllabus/tracker/update`,data)
}
